
















import { defineComponent, ref, onMounted, } from '@vue/composition-api';
import { ScreenDialog, FitButton } from '@tencent/wphk-ui';
import { useActTipDialog } from './hooks/useActTipDialog';

export default defineComponent({
  name: 'ActTipDialog',
  components: {
    ScreenDialog,
    FitButton,
  },
  setup() {
    // 弹窗
    const nineActTipDialog = ref<InstanceType<typeof ScreenDialog> | null>(null);

    const { checkIfHadShow, setShowTag } = useActTipDialog();

    onMounted(() => {
      if (!checkIfHadShow()) {
        nineActTipDialog.value?.show();
        setShowTag();
        return;
      }
    });

    function hide() {
      nineActTipDialog.value?.hide();
    }

    return {
      nineActTipDialog,
      hide,
    }
  },
});
